import {
    MsgBuyNFT,
    MsgCancelAuction,
    MsgCreateAuction,
    MsgDeListNFT,
    MsgEditListing,
    MsgListNFT,
    MsgPlaceBid,
} from './omniflix_custom_ts_types/marketplace/v1beta1/tx';
import {
    MsgBurnONFT,
    MsgCreateDenom,
    MsgMintONFT,
    MsgTransferDenom,
    MsgTransferONFT,
    MsgUpdateDenom,
} from './omniflix_custom_ts_types/onft/v1beta1/tx';
import {
    MsgCancelCampaign,
    MsgClaim,
    MsgCreateCampaign,
    MsgDepositCampaign,
} from './omniflix_custom_ts_types/itc/v1/tx';
import { MsgClaimStreamedAmount, MsgStopStream, MsgStreamSend } from './omniflix_custom_ts_types/streampay/v1/tx';
import {
    MsgCancelLease,
    MsgCloseMediaNode,
    MsgDepositMediaNode,
    MsgExtendLease,
    MsgLeaseMediaNode,
    MsgRegisterMediaNode,
    MsgUpdateMediaNode,
} from './omniflix_custom_ts_types/medianode/v1beta1/tx';

export const customTypes = {
    // ONFT
    CreateDenom: {
        typeUrl: '/OmniFlix.onft.v1beta1.MsgCreateDenom',
        type: MsgCreateDenom,
    },
    UpdateDenom: {
        typeUrl: '/OmniFlix.onft.v1beta1.MsgUpdateDenom',
        type: MsgUpdateDenom,
    },
    TransferDenom: {
        typeUrl: '/OmniFlix.onft.v1beta1.MsgTransferDenom',
        type: MsgTransferDenom,
    },
    MintONFT: {
        typeUrl: '/OmniFlix.onft.v1beta1.MsgMintONFT',
        type: MsgMintONFT,
    },
    TransferONFT: {
        typeUrl: '/OmniFlix.onft.v1beta1.MsgTransferONFT',
        type: MsgTransferONFT,
    },
    BurnONFT: {
        typeUrl: '/OmniFlix.onft.v1beta1.MsgBurnONFT',
        type: MsgBurnONFT,
    },
    // Marketplace
    ListNFT: {
        typeUrl: '/OmniFlix.marketplace.v1beta1.MsgListNFT',
        type: MsgListNFT,
    },
    EditListing: {
        typeUrl: '/OmniFlix.marketplace.v1beta1.MsgEditListing',
        type: MsgEditListing,
    },
    DeListNFT: {
        typeUrl: '/OmniFlix.marketplace.v1beta1.MsgDeListNFT',
        type: MsgDeListNFT,
    },
    BuyNFT: {
        typeUrl: '/OmniFlix.marketplace.v1beta1.MsgBuyNFT',
        type: MsgBuyNFT,
    },
    CreateAuction: {
        typeUrl: '/OmniFlix.marketplace.v1beta1.MsgCreateAuction',
        type: MsgCreateAuction,
    },
    CancelAuction: {
        typeUrl: '/OmniFlix.marketplace.v1beta1.MsgCancelAuction',
        type: MsgCancelAuction,
    },
    PlaceBid: {
        typeUrl: '/OmniFlix.marketplace.v1beta1.MsgPlaceBid',
        type: MsgPlaceBid,
    },
    // ITC
    CreateCampaign: {
        typeUrl: '/OmniFlix.itc.v1.MsgCreateCampaign',
        type: MsgCreateCampaign,
    },
    CancelCampaign: {
        typeUrl: '/OmniFlix.itc.v1.MsgCancelCampaign',
        type: MsgCancelCampaign,
    },
    Claim: {
        typeUrl: '/OmniFlix.itc.v1.MsgClaim',
        type: MsgClaim,
    },
    DepositCampaign: {
        typeUrl: '/OmniFlix.itc.v1.MsgDepositCampaign',
        type: MsgDepositCampaign,
    },
    // Stream Pay
    StreamSend: {
        typeUrl: '/OmniFlix.streampay.v1.MsgStreamSend',
        type: MsgStreamSend,
    },
    StopStream: {
        typeUrl: '/OmniFlix.streampay.v1.MsgStopStream',
        type: MsgStopStream,
    },
    ClaimStreamedAmount: {
        typeUrl: '/OmniFlix.streampay.v1.MsgClaimStreamedAmount',
        type: MsgClaimStreamedAmount,
    },
    // Media Node
    LeaseMediaNode: {
        typeUrl: '/OmniFlix.medianode.v1beta1.MsgLeaseMediaNode',
        type: MsgLeaseMediaNode,
    },
    ExtendLease: {
        typeUrl: '/OmniFlix.medianode.v1beta1.MsgExtendLease',
        type: MsgExtendLease,
    },
    CancelLease: {
        typeUrl: '/OmniFlix.medianode.v1beta1.MsgCancelLease',
        type: MsgCancelLease,
    },
    DepositMediaNode: {
        typeUrl: '/OmniFlix.medianode.v1beta1.MsgDepositMediaNode',
        type: MsgDepositMediaNode,
    },
    RegisterMediaNode: {
        typeUrl: '/OmniFlix.medianode.v1beta1.MsgRegisterMediaNode',
        type: MsgRegisterMediaNode,
    },
    CloseMediaNode: {
        typeUrl: '/OmniFlix.medianode.v1beta1.MsgCloseMediaNode',
        type: MsgCloseMediaNode,
    },
    UpdateMediaNode: {
        typeUrl: '/OmniFlix.medianode.v1beta1.MsgUpdateMediaNode',
        type: MsgUpdateMediaNode,
    },
};

export const customRegistry = [[
    customTypes.CreateDenom.typeUrl,
    customTypes.CreateDenom.type,
], [
    customTypes.UpdateDenom.typeUrl,
    customTypes.UpdateDenom.type,
], [
    customTypes.TransferDenom.typeUrl,
    customTypes.TransferDenom.type,
], [
    customTypes.MintONFT.typeUrl,
    customTypes.MintONFT.type,
], [
    customTypes.TransferONFT.typeUrl,
    customTypes.TransferONFT.type,
], [
    customTypes.BurnONFT.typeUrl,
    customTypes.BurnONFT.type,
], [
    customTypes.ListNFT.typeUrl,
    customTypes.ListNFT.type,
], [
    customTypes.EditListing.typeUrl,
    customTypes.EditListing.type,
], [
    customTypes.DeListNFT.typeUrl,
    customTypes.DeListNFT.type,
], [
    customTypes.BuyNFT.typeUrl,
    customTypes.BuyNFT.type,
], [
    customTypes.CreateAuction.typeUrl,
    customTypes.CreateAuction.type,
], [
    customTypes.CancelAuction.typeUrl,
    customTypes.CancelAuction.type,
], [
    customTypes.PlaceBid.typeUrl,
    customTypes.PlaceBid.type,
], [
    customTypes.CreateCampaign.typeUrl,
    customTypes.CreateCampaign.type,
], [
    customTypes.CancelCampaign.typeUrl,
    customTypes.CancelCampaign.type,
], [
    customTypes.Claim.typeUrl,
    customTypes.Claim.type,
], [
    customTypes.DepositCampaign.typeUrl,
    customTypes.DepositCampaign.type,
], [
    customTypes.LeaseMediaNode.typeUrl,
    customTypes.LeaseMediaNode.type,
], [
    customTypes.ExtendLease.typeUrl,
    customTypes.ExtendLease.type,
], [
    customTypes.CancelLease.typeUrl,
    customTypes.CancelLease.type,
], [
    customTypes.DepositMediaNode.typeUrl,
    customTypes.DepositMediaNode.type,
], [
    customTypes.RegisterMediaNode.typeUrl,
    customTypes.RegisterMediaNode.type,
], [
    customTypes.CloseMediaNode.typeUrl,
    customTypes.CloseMediaNode.type,
], [
    customTypes.UpdateMediaNode.typeUrl,
    customTypes.UpdateMediaNode.type,
]];
